import * as React from "react";

export const Button = ({ className = "", children, ...props }) => {
  return (
    <button
      className={`inline-flex items-center justify-center rounded-2xl bg-blue-600 px-4 py-2 text-white text-sm font-medium hover:bg-blue-700 transition ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};
